import React from 'react';

import Paper from '@material-ui/core/Paper';

import FlexContainer from '@components/FlexContainer/FlexContainer';

import './PrivacyPolicy.scss';

const PrivacyPolicy = () => (
  <div className="privacy-policy">
    <FlexContainer>
      <Paper className="privacy-policy__paper">
        <h2 className="privacy-policy__title">
          Privacy Policy
        </h2>
        <p className="privacy-policy__paragraph">
          Process General LLC (&quot;PG&quot;) is committed to protecting your privacy and earning
          your trust. PG collects personal and non-personal information on its websites
          and has created this Privacy Policy in order to explain our information
          collection practice.
        </p>
        <h3 className="privacy-policy__header">
          Collected Information
        </h3>
        <p className="privacy-policy__paragraph">
          To participate in certain activities and to obtain certain services, a user is
          asked to provide varying amounts of personal information. Some information is
          mandatory while other information is discretionary. Each activity and service
          requires or requests different types of information in order for users to
          participate. Activities or services that require provision of personal
          information generally seek full name and email address. Depending on the activity
          or service a user desires, we also may request additional personal information.
        </p>
        <h3 className="privacy-policy__header">
          Information Use
        </h3>
        <p className="privacy-policy__paragraph">
          Personal information is collected and used primarily for evaluating job
          candidates, profiling prospective customers, or building our mailing list
          for information distribution. If a user prefers not to receive emails or
          other forms of communication unrelated to orders and requests for services,
          the user may opt-out. We may also use personal information to contact a user
          in connection with the user&apos;s inappropriate use any PG website. We do not sell,
          rent, share, or otherwise dispose of the personal information collected to third
          parties. We may disclose your personal information when required by law or in
          the good-faith belief that such disclosure is necessary to comply with law.
          Additionally, we provide public-access information about certain consumer and
          business bankruptcies for the convenience of bankruptcy professionals and for
          interested members of the public. We use non-personal information such as
          demographic data to analyze and develop our marketing strategy. We use
          non-personal information to determine how you found out about us, what your
          interests are regarding our services, and how to further improve our websites
          and our service towards you. We may also share non-personal
          information with third parties.
        </p>
        <h3 className="privacy-policy__header">
          Security
        </h3>
        <p className="privacy-policy__paragraph">
          PG has taken steps to ensure that any information PG collects is secure by,
          among other things, limiting the number of people who have physical access
          to database servers, utilizing electronic security systems, and using password
          protections that guard against unauthorized access. When personal information
          is transmitted to PG, it is protected by a &quot;firewall&quot; (a combination of hardware
          and software that helps keep unauthorized visitors from accessing information
          within PG&apos;s computer network), as well as industry standard Secure Sockets Layer
          (SSL) encryption. However, no data transmission over the Internet is 100% secure.
          Therefore, PG cannot warrant or guarantee the security of any transmission to PG,
          or be responsible for the theft, destruction, or inadvertent disclosure of information.
        </p>
        <h3 className="privacy-policy__header">
          Cookies
        </h3>
        <p className="privacy-policy__paragraph">
          &quot;Cookies&quot; are information files that your web browser places on your computer
          when you visit a website. PG uses cookies and session IDs to authenticate users.
          Cookies and session IDs may also be used to automate data entry functions.
          PG does not obtain personal information from cookies or session IDs and does
          not link any data collected through cookies or session IDs to any personal information.
        </p>
        <h3 className="privacy-policy__header">
          Links
        </h3>
        <p className="privacy-policy__paragraph">
          Our Privacy Statement applies solely to information collection practice on PG
          websites. Please be aware that PG has no control or influence over the privacy
          policies other websites that are linked to or from this website. We encourage
          our users to be aware when they leave this website and to read the privacy
          policies of each website they visit.
        </p>
        <h3 className="privacy-policy__header">
          Updates
        </h3>
        <p className="privacy-policy__paragraph">
          If we later change our Privacy Policy, we will post those changes on our
          homepage so our users are always aware of what information we collect,
          how we use it, and under what circumstances, if any, we disclose it.
        </p>
        <h3 className="privacy-policy__header">
          Consent
        </h3>
        <p className="privacy-policy__paragraph">
          By using any PG website, you consent to the terms of our privacy policy
          regarding the use and processing of personal information, and all other
          terms that may be set forth on any website where PG collects personal
          information. You further expressly agree that your rights and obligations,
          as well as the rights and obligations of PG, shall be governed, at PG&apos;s
          sole discretion, by the laws of the State of Nevada.
        </p>
      </Paper>
    </FlexContainer>
  </div>
);

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/routes/PrivacyPolicy/PrivacyPolicy.js